import { Box, Stack, Typography, type TypographyProps } from '@mui/material';
import React from 'react';
import TooltipHardened from '../TooltipHardened';

interface Props extends TypographyProps {
  label: string;
  tooltip?: string;
  /** Optional description text displayed below the header */
  description?: string;
}

export const StyledFormHeader = ({ label, tooltip, description, ...props }: Props): React.JSX.Element => {
  const header = (
    <TooltipHardened tooltip={tooltip}>
      <Typography
        variant="overline"
        color="primary"
        fontWeight={700}
        textAlign="center"
        width="100%"
        display="inline-block"
        {...props}
        sx={{ userSelect: 'none' }}
      >
        {label}
      </Typography>
    </TooltipHardened>
  );

  if (!description) {
    return header;
  }

  return (
    <Stack spacing={0.5} width="100%">
      {header}
      <Stack direction="row" alignItems="center" spacing={1.5} width="100%">
        <Box sx={{ flex: 1, borderBottom: 1, borderColor: 'divider' }} />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontStyle: 'italic', userSelect: 'none', whiteSpace: 'nowrap' }}
        >
          {description}
        </Typography>
        <Box sx={{ flex: 1, borderBottom: 1, borderColor: 'divider' }} />
      </Stack>
    </Stack>
  );
};
